<template>
 <div>
 	<ul class="searchList" v-for="item in searchData">
 		<li @click="details(item.id,item.url,item.cateName,item.proType[0])">{{item.cateName}}</li>
 	</ul>
 </div>
</template>

<script>
	export default{
		 props:['searchData'],
		 methods: {
	      details(id,urls,value,protype){
	      	  localStorage.setItem("tid",id);
	    	  localStorage.removeItem("faceId");
	    	  localStorage.removeItem("ttype");
	    	  this.$emit('refHistoryItems', value);
	    	  if(urls!=""){
	    	  	location.href=urls;
	    	  }else if(protype == 0){
	    	  	localStorage.setItem("ttype",protype);
                this.$router.push({ path: "/Reallygood" });
	    	  }else{
	    	  	this.$router.push({path: "/Cami"});
	    	  }
	      },
	    }
	}
</script>
<style scoped="scoped">
 .searchList li{background: #fff;border-bottom: 1px solid #eee;color: #333;height: 50px;line-height: 50px;padding-left: 12px;font-size: 0.9rem;}
</style>



// WEBPACK FOOTER //
// src/components/searchList.vue